import React, { useRef, useMemo } from "react";
import { Canvas, useFrame, useThree } from "@react-three/fiber";
import { BufferGeometry, Float32BufferAttribute, PointsMaterial } from "three";

const Stars = () => {
  const mesh = useRef();
  const { camera, mouse, scene } = useThree();

  const positions = useMemo(() => {
    const pos = [];
    for (let i = 0; i < 8000; i++) {
      const x = (Math.random() - 0.5) * 2500;
      const y = (Math.random() - 0.5) * 2500;
      const z = (Math.random() - 0.5) * 2500;
      pos.push(x, y, z);
    }
    return new Float32Array(pos);
  }, []);

  const geometry = useMemo(() => {
    const geom = new BufferGeometry();
    geom.setAttribute("position", new Float32BufferAttribute(positions, 3));
    return geom;
  }, [positions]);

  const material = useMemo(
    () => new PointsMaterial({ color: 0xffffff, size: 0.5 }),
    []
  );

  useFrame(() => {
    if (mesh.current) {
      mesh.current.rotation.x += 0.001;
      mesh.current.rotation.y += 0.001;
    }

    const mouseX = mouse.x * 500;
    const mouseY = -mouse.y * 500;

    camera.position.x += (mouseX - camera.position.x) * 0.05;
    camera.position.y += (mouseY - camera.position.y) * 0.05;
    camera.lookAt(scene.position);
  });

  return <points ref={mesh} geometry={geometry} material={material} />;
};

const GalaxyAnimation = () => {
  return (
    <div className="h-screen">
      <Canvas camera={{ position: [0, 0, 500], fov: 80 }}>
        <Stars />
      </Canvas>
    </div>
  );
};

export default GalaxyAnimation;
